// extracted by mini-css-extract-plugin
export default {"root":"z3UFlr","RibbonsMenuButtonNSkin":"prvpFy","ribbonsMenuButtonNSkin":"prvpFy","linkElement":"ushGpg","wrapper":"F1Yl8S","label":"LtXyyQ"};